import React from 'react';

import {
    Link as LinkIcon,
    LocationOnOutlined,
    AssignmentTurnedInOutlined,
    LocalShippingOutlined,
    SettingsOutlined,
    BusinessOutlined,
    PeopleOutline,
    GroupsOutlined,
    AltRouteOutlined,
    PersonOutline,
    NotificationsOutlined,
    MailOutline,
    FeedbackOutlined,
    CookieOutlined,
    HelpOutline
} from '@mui/icons-material';

import { isGtmEnabled, openCookieBanner } from '../../utils/analytics';

type SubLinkType = {
    name: string;
    icon: JSX.Element;
    path?: string;
    action?: () => void;
    isCarrier?: boolean;
};

type LinkType = {
    name: string;
    icon: JSX.Element;
    path?: string;
    key?: string;
    links?: SubLinkType[];
    isAdmin?: boolean;
    isCarrier?: boolean;
};

export default function getMenuLinks(
    { isAdmin, isCarrier }
    : { isAdmin: boolean, isCarrier: boolean }
): LinkType[] {
    const menuLinks = [{
        name: 'Marknad',
        icon: <LocationOnOutlined />,
        path: '/market',
        isCarrier: true
    }, {
        name: 'Boka transport',
        icon: <AssignmentTurnedInOutlined />,
        path: '/orders'
    }, {
        name: 'Kör uppdrag',
        icon: <LocalShippingOutlined />,
        path: '/jobs',
        isCarrier: true
    }, {
        name: 'Administration',
        icon: <SettingsOutlined />,
        key: 'admin',
        isAdmin: true,
        links: [{
            name: 'Företagsprofil',
            icon: <BusinessOutlined />,
            path: '/company-profile'
        }, {
            name: 'Rutter',
            icon: <AltRouteOutlined />,
            path: '/routes',
            isCarrier: true
        }, {
            name: 'Användare',
            icon: <PeopleOutline />,
            path: '/users'
        }, {
            name: 'Grupper',
            icon: <GroupsOutlined />,
            path: '/groups'
        }, {
            name: 'Integrationer',
            icon: <LinkIcon />,
            path: '/integrations'
        }]
    }, {
        name: 'Mitt konto',
        icon: <PersonOutline />,
        key: 'account',
        links: [{
            name: 'Min profil',
            icon: <PersonOutline />,
            path: '/user-profile'
        }, {
            name: 'Bevakningar',
            icon: <NotificationsOutlined />,
            path: '/watchlists',
            isCarrier: true
        }, {
            name: 'Bjud in',
            icon: <MailOutline />,
            path: '/invite'
        }, {
            name: 'Feedback',
            icon: <FeedbackOutlined />,
            path: '/feedback'
        }, ...(isGtmEnabled() ? [{
            name: 'Cookies',
            icon: <CookieOutlined />,
            action: openCookieBanner
        }] : [])]
    // }, {
    //     name: 'Premium',
    //     icon: <Star />,
    //     key: 'premium',
    //     path: '/premium',
    //     isCarrier: true
    }, {
        name: 'Hjälp',
        icon: <HelpOutline />,
        path: '/help'
    }

    ];
    const adminLinks = isAdmin
        ? menuLinks
        : menuLinks.filter((l) => !l.isAdmin);

    const carrierAdminLinks = isCarrier
        ? adminLinks
        : adminLinks
            .filter((l: LinkType) => !l.isCarrier)
            // eslint-disable-next-line no-confusing-arrow
            .map((l: LinkType) => l.links
                ? { ...l, links: l.links?.filter((sl: SubLinkType) => !sl.isCarrier) }
                : l);

    return carrierAdminLinks;
}
